import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BBInvitationList, BBInvitationQuery, BBInvitationQueryDefaultValues } from 'src/app/components/invitations/bb-invitations/bb-invitation-list';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { AuthService } from 'src/app/services/auth.service';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-bb-invitation-list',
    templateUrl: './bb-invitation-list.component.html',
    styleUrls: ['./bb-invitation-list.component.scss'],
    standalone: false
})
export class BbInvitationListComponent {
  bbinvitationslist:BBInvitationList[]=[];
  queryFilter:BBInvitationQuery=BBInvitationQueryDefaultValues()

  totalRecords: number = 0;
  columnsToDisplay = [
    'caseid','email','coach','expirydate','linkaccessed', 'status',
  ]
  showAddButton=true;
  //queryFilter:TagQueryFilter=TagQueryFilterDefaultValues();
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef
  information:string=''
  coachedUsers:any[]=[]
  pageName = CheckPageAccess.BBINVITATIONS
  constructor(private _bbinvitationservice:BbInvitationService,private _userservice:UserService,private _authservice:AuthService) { }

  ngOnInit()
  {
    this.information = "<h4>Status Definitions</h4><br/><span>Active:</span> The link is currently Active and can be used by the participant.<br/><br/>"+
    "<span>Used:</span> The link has been used by the participant and is now inactive.<br/><br/>"+
    "<span>Withdrawn:</span> The link has been manually withdrawn by the organizer and cannot be used.<br/><br/>"+
    "<span>Expired:</span> The link has reached its expiry date and cannot be used.<br/><br/>"
    this._userservice.getCoachedUsers().subscribe({
      next:(response)=>{
          this.coachedUsers = response;
          this.search();
      }
    })

    this.showAddButton = this._authservice.getAccessControl().addBBInvitation

  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex
    this.queryFilter.PageSize = e.pageSize
    this.searchWithFilters();
  }

  private searchWithFilters() {

    this._bbinvitationservice.getAllBBInvitations(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          console.log(this.totalRecords);
          this.noResults.setTotal(this.totalRecords);
        }
        this.bbinvitationslist = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
		this.submitButton.nativeElement.click();
		event.preventDefault();
	  }
	}

  resetFilters() {
    this.queryFilter = BBInvitationQueryDefaultValues();
    this.search();
  }

  search() {
    this.searchWithFilters();
    }
}
